import router from "./index";
import cloneDeep from 'lodash/cloneDeep'
import { asyncRoutes } from './index'
import Home from '../views/Home.vue'
const CardCheckInfo = () => import(/* webpackChunkName: "cybercash" */ '../views/cybercash/cardCheckInfo.vue')
const permission = function () {
  const asyncRoutesArr = cloneDeep(asyncRoutes)
  const userInfo = JSON.parse(localStorage.getItem('userInfo')).userInfoVO
  const asyncRouterObj = {}, routerName = [], menusObj = {}
  for (let i = 0; i < userInfo.menus.length; i++) {
    for (let j = 0; j < asyncRoutesArr.length; j++) {
      if (userInfo.menus[i].menuName === asyncRoutesArr[j].name) {
        !asyncRoutesArr[j].redirect && (asyncRoutesArr[j].redirect = userInfo.menus[i].children[0].url)
        asyncRouterObj[asyncRoutesArr[j].name] = asyncRoutesArr[j]
        menusObj[userInfo.menus[i].menuName] = userInfo.menus[i]
        routerName.push(asyncRoutesArr[j].name)
        continue;
      }
    }
  }


  const menusChild = {}

  routerName.forEach(item => {
    menusChild[item] = menusObj[item].children.map(menu => {
      return menu.menuName
    })
  })


  const children = {}
  routerName.forEach(item => {
    children[item] = []
    asyncRouterObj[item].children.forEach(child => {
      if (menusChild[item].includes(child.meta.title)) {
        children[item].push(child)
      }
    })
    if (children['智慧卡']) {
      children[item].push({
        path: 'cardCheckInfo',
        meta: { title: '卡信息查询 / 卡详情' },
        component: CardCheckInfo
      })
    }
    asyncRouterObj[item].children = children[item]
  })

  const menusArr = []
  routerName.forEach(item => {
    menusArr.push(asyncRouterObj[item])
  })
  const redirectPath = menusArr[0].path + '/' + menusArr[0].children[0].path
  const general = [
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect: redirectPath
    },
    {
      path: '*',
      redirect: redirectPath
    },

  ]
  router.addRoutes(menusArr)
  router.addRoutes(general)
}


export {
  permission
}
